import { EventContextProvider } from "@codat/analytics";
import useQueryParams from "hooks/useQueryParams";
import { createContext, useContext } from "react";

export interface DemoMode {
  isDemo: boolean;
}

export const DemoModeContext = createContext<DemoMode>({ isDemo: false });

export const DemoModeProvider = ({ children }: React.PropsWithChildren) => {
  const params = useQueryParams();
  const isDemo = params.get("link.demo") === "true";

  return (
    <DemoModeContext.Provider value={{ isDemo }}>
      <EventContextProvider data={{ demoMode: isDemo }}>
        {children}
      </EventContextProvider>
    </DemoModeContext.Provider>
  );
};

export const useDemoMode = (): DemoMode => useContext(DemoModeContext);
